import {inject, InjectionToken, Pipe, PipeTransform} from '@angular/core';
import {HeightToWeight} from '../constants/height-to.weight';

// Accepted types
export type SdLevel = 'SD3-' | 'SD2-' | 'SD1-' | 'SD0' | 'SD1' | 'SD2' | 'SD3';

// Rótulos de Peso × Talla. Casam EXATAMENTE com WeightHeightService.getLevelMap
// (o mesmo texto vai para o Firebase em visit.heightToWeightLevel). Déficit de
// peso-para-altura é desnutrição AGUDA (emaciação), não crónica.
export const SD_LEVEL_LABELS = new InjectionToken<
    Partial<Record<SdLevel, string>>
>('SD_LEVEL_LABELS', {
    factory: () => ({
        'SD3-': HeightToWeight.SEVERE_ACUTE_MALNUTRITION,    // 'Desnutrición Aguda severa'
        'SD2-': HeightToWeight.MODERATE_ACUTE_MALNUTRITION,  // 'Desnutrición Aguda modera'
        'SD1-': HeightToWeight.NORMAL_LEVEL,                 // 'Normal'
        'SD0': HeightToWeight.NORMAL_LEVEL,                  // 'Normal'
        'SD1': HeightToWeight.RISK_OF_OVERWEIGHT,            // 'Riesgo de Sobrepeso'
        'SD2': HeightToWeight.OVERWEIGHT,                    // 'Sobrepeso'
        'SD3': HeightToWeight.OBESITY,                       // 'Obesidad'
    }),
});

@Pipe({
    name: 'heightWeightMalnutritionLevel',
    pure: true,
})
export class HeightWeightMalnutritionLevel implements PipeTransform {
    private labels = inject(SD_LEVEL_LABELS);

    /**
     * @param value  Nível SD (ex.: 'SD2-')
     * @param fallback Texto opcional caso não exista rótulo (default: próprio value)
     */
    transform(value: SdLevel | string | null | undefined, fallback?: string): string {
        if (!value) {
            return fallback ?? 'No medido';
        }
        const v = value as SdLevel;
        return this.labels[v] ?? fallback ?? String(value);
    }
}
